export default __webpack_public_path__ + "static/media/procedure-header.02a2c98e.png";